import { __assign, __extends } from "tslib";
import { GlueServiceException as __BaseException } from "./GlueServiceException";
var AccessDeniedException = (function (_super) {
    __extends(AccessDeniedException, _super);
    function AccessDeniedException(opts) {
        var _this = _super.call(this, __assign({ name: "AccessDeniedException", $fault: "client" }, opts)) || this;
        _this.name = "AccessDeniedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AccessDeniedException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return AccessDeniedException;
}(__BaseException));
export { AccessDeniedException };
export var AggFunction;
(function (AggFunction) {
    AggFunction["avg"] = "avg";
    AggFunction["count"] = "count";
    AggFunction["countDistinct"] = "countDistinct";
    AggFunction["first"] = "first";
    AggFunction["kurtosis"] = "kurtosis";
    AggFunction["last"] = "last";
    AggFunction["max"] = "max";
    AggFunction["min"] = "min";
    AggFunction["skewness"] = "skewness";
    AggFunction["stddev_pop"] = "stddev_pop";
    AggFunction["stddev_samp"] = "stddev_samp";
    AggFunction["sum"] = "sum";
    AggFunction["sumDistinct"] = "sumDistinct";
    AggFunction["var_pop"] = "var_pop";
    AggFunction["var_samp"] = "var_samp";
})(AggFunction || (AggFunction = {}));
var AlreadyExistsException = (function (_super) {
    __extends(AlreadyExistsException, _super);
    function AlreadyExistsException(opts) {
        var _this = _super.call(this, __assign({ name: "AlreadyExistsException", $fault: "client" }, opts)) || this;
        _this.name = "AlreadyExistsException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AlreadyExistsException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return AlreadyExistsException;
}(__BaseException));
export { AlreadyExistsException };
var EntityNotFoundException = (function (_super) {
    __extends(EntityNotFoundException, _super);
    function EntityNotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "EntityNotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "EntityNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EntityNotFoundException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return EntityNotFoundException;
}(__BaseException));
export { EntityNotFoundException };
var GlueEncryptionException = (function (_super) {
    __extends(GlueEncryptionException, _super);
    function GlueEncryptionException(opts) {
        var _this = _super.call(this, __assign({ name: "GlueEncryptionException", $fault: "client" }, opts)) || this;
        _this.name = "GlueEncryptionException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, GlueEncryptionException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return GlueEncryptionException;
}(__BaseException));
export { GlueEncryptionException };
var InternalServiceException = (function (_super) {
    __extends(InternalServiceException, _super);
    function InternalServiceException(opts) {
        var _this = _super.call(this, __assign({ name: "InternalServiceException", $fault: "server" }, opts)) || this;
        _this.name = "InternalServiceException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalServiceException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return InternalServiceException;
}(__BaseException));
export { InternalServiceException };
var InvalidInputException = (function (_super) {
    __extends(InvalidInputException, _super);
    function InvalidInputException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidInputException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidInputException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidInputException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return InvalidInputException;
}(__BaseException));
export { InvalidInputException };
var OperationTimeoutException = (function (_super) {
    __extends(OperationTimeoutException, _super);
    function OperationTimeoutException(opts) {
        var _this = _super.call(this, __assign({ name: "OperationTimeoutException", $fault: "client" }, opts)) || this;
        _this.name = "OperationTimeoutException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, OperationTimeoutException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return OperationTimeoutException;
}(__BaseException));
export { OperationTimeoutException };
var ResourceNumberLimitExceededException = (function (_super) {
    __extends(ResourceNumberLimitExceededException, _super);
    function ResourceNumberLimitExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceNumberLimitExceededException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceNumberLimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNumberLimitExceededException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ResourceNumberLimitExceededException;
}(__BaseException));
export { ResourceNumberLimitExceededException };
var ResourceNotReadyException = (function (_super) {
    __extends(ResourceNotReadyException, _super);
    function ResourceNotReadyException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceNotReadyException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceNotReadyException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotReadyException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ResourceNotReadyException;
}(__BaseException));
export { ResourceNotReadyException };
export var BlueprintStatus;
(function (BlueprintStatus) {
    BlueprintStatus["ACTIVE"] = "ACTIVE";
    BlueprintStatus["CREATING"] = "CREATING";
    BlueprintStatus["FAILED"] = "FAILED";
    BlueprintStatus["UPDATING"] = "UPDATING";
})(BlueprintStatus || (BlueprintStatus = {}));
export var LastCrawlStatus;
(function (LastCrawlStatus) {
    LastCrawlStatus["CANCELLED"] = "CANCELLED";
    LastCrawlStatus["FAILED"] = "FAILED";
    LastCrawlStatus["SUCCEEDED"] = "SUCCEEDED";
})(LastCrawlStatus || (LastCrawlStatus = {}));
export var CrawlerLineageSettings;
(function (CrawlerLineageSettings) {
    CrawlerLineageSettings["DISABLE"] = "DISABLE";
    CrawlerLineageSettings["ENABLE"] = "ENABLE";
})(CrawlerLineageSettings || (CrawlerLineageSettings = {}));
export var RecrawlBehavior;
(function (RecrawlBehavior) {
    RecrawlBehavior["CRAWL_EVENT_MODE"] = "CRAWL_EVENT_MODE";
    RecrawlBehavior["CRAWL_EVERYTHING"] = "CRAWL_EVERYTHING";
    RecrawlBehavior["CRAWL_NEW_FOLDERS_ONLY"] = "CRAWL_NEW_FOLDERS_ONLY";
})(RecrawlBehavior || (RecrawlBehavior = {}));
export var ScheduleState;
(function (ScheduleState) {
    ScheduleState["NOT_SCHEDULED"] = "NOT_SCHEDULED";
    ScheduleState["SCHEDULED"] = "SCHEDULED";
    ScheduleState["TRANSITIONING"] = "TRANSITIONING";
})(ScheduleState || (ScheduleState = {}));
export var DeleteBehavior;
(function (DeleteBehavior) {
    DeleteBehavior["DELETE_FROM_DATABASE"] = "DELETE_FROM_DATABASE";
    DeleteBehavior["DEPRECATE_IN_DATABASE"] = "DEPRECATE_IN_DATABASE";
    DeleteBehavior["LOG"] = "LOG";
})(DeleteBehavior || (DeleteBehavior = {}));
export var UpdateBehavior;
(function (UpdateBehavior) {
    UpdateBehavior["LOG"] = "LOG";
    UpdateBehavior["UPDATE_IN_DATABASE"] = "UPDATE_IN_DATABASE";
})(UpdateBehavior || (UpdateBehavior = {}));
export var CrawlerState;
(function (CrawlerState) {
    CrawlerState["READY"] = "READY";
    CrawlerState["RUNNING"] = "RUNNING";
    CrawlerState["STOPPING"] = "STOPPING";
})(CrawlerState || (CrawlerState = {}));
export var StartingPosition;
(function (StartingPosition) {
    StartingPosition["EARLIEST"] = "earliest";
    StartingPosition["LATEST"] = "latest";
    StartingPosition["TRIM_HORIZON"] = "trim_horizon";
})(StartingPosition || (StartingPosition = {}));
export var FilterOperation;
(function (FilterOperation) {
    FilterOperation["EQ"] = "EQ";
    FilterOperation["GT"] = "GT";
    FilterOperation["GTE"] = "GTE";
    FilterOperation["ISNULL"] = "ISNULL";
    FilterOperation["LT"] = "LT";
    FilterOperation["LTE"] = "LTE";
    FilterOperation["REGEX"] = "REGEX";
})(FilterOperation || (FilterOperation = {}));
export var FilterValueType;
(function (FilterValueType) {
    FilterValueType["COLUMNEXTRACTED"] = "COLUMNEXTRACTED";
    FilterValueType["CONSTANT"] = "CONSTANT";
})(FilterValueType || (FilterValueType = {}));
export var FilterLogicalOperator;
(function (FilterLogicalOperator) {
    FilterLogicalOperator["AND"] = "AND";
    FilterLogicalOperator["OR"] = "OR";
})(FilterLogicalOperator || (FilterLogicalOperator = {}));
export var UpdateCatalogBehavior;
(function (UpdateCatalogBehavior) {
    UpdateCatalogBehavior["LOG"] = "LOG";
    UpdateCatalogBehavior["UPDATE_IN_DATABASE"] = "UPDATE_IN_DATABASE";
})(UpdateCatalogBehavior || (UpdateCatalogBehavior = {}));
export var JDBCDataType;
(function (JDBCDataType) {
    JDBCDataType["ARRAY"] = "ARRAY";
    JDBCDataType["BIGINT"] = "BIGINT";
    JDBCDataType["BINARY"] = "BINARY";
    JDBCDataType["BIT"] = "BIT";
    JDBCDataType["BLOB"] = "BLOB";
    JDBCDataType["BOOLEAN"] = "BOOLEAN";
    JDBCDataType["CHAR"] = "CHAR";
    JDBCDataType["CLOB"] = "CLOB";
    JDBCDataType["DATALINK"] = "DATALINK";
    JDBCDataType["DATE"] = "DATE";
    JDBCDataType["DECIMAL"] = "DECIMAL";
    JDBCDataType["DISTINCT"] = "DISTINCT";
    JDBCDataType["DOUBLE"] = "DOUBLE";
    JDBCDataType["FLOAT"] = "FLOAT";
    JDBCDataType["INTEGER"] = "INTEGER";
    JDBCDataType["JAVA_OBJECT"] = "JAVA_OBJECT";
    JDBCDataType["LONGNVARCHAR"] = "LONGNVARCHAR";
    JDBCDataType["LONGVARBINARY"] = "LONGVARBINARY";
    JDBCDataType["LONGVARCHAR"] = "LONGVARCHAR";
    JDBCDataType["NCHAR"] = "NCHAR";
    JDBCDataType["NCLOB"] = "NCLOB";
    JDBCDataType["NULL"] = "NULL";
    JDBCDataType["NUMERIC"] = "NUMERIC";
    JDBCDataType["NVARCHAR"] = "NVARCHAR";
    JDBCDataType["OTHER"] = "OTHER";
    JDBCDataType["REAL"] = "REAL";
    JDBCDataType["REF"] = "REF";
    JDBCDataType["REF_CURSOR"] = "REF_CURSOR";
    JDBCDataType["ROWID"] = "ROWID";
    JDBCDataType["SMALLINT"] = "SMALLINT";
    JDBCDataType["SQLXML"] = "SQLXML";
    JDBCDataType["STRUCT"] = "STRUCT";
    JDBCDataType["TIME"] = "TIME";
    JDBCDataType["TIMESTAMP"] = "TIMESTAMP";
    JDBCDataType["TIMESTAMP_WITH_TIMEZONE"] = "TIMESTAMP_WITH_TIMEZONE";
    JDBCDataType["TIME_WITH_TIMEZONE"] = "TIME_WITH_TIMEZONE";
    JDBCDataType["TINYINT"] = "TINYINT";
    JDBCDataType["VARBINARY"] = "VARBINARY";
    JDBCDataType["VARCHAR"] = "VARCHAR";
})(JDBCDataType || (JDBCDataType = {}));
export var GlueRecordType;
(function (GlueRecordType) {
    GlueRecordType["BIGDECIMAL"] = "BIGDECIMAL";
    GlueRecordType["BYTE"] = "BYTE";
    GlueRecordType["DATE"] = "DATE";
    GlueRecordType["DOUBLE"] = "DOUBLE";
    GlueRecordType["FLOAT"] = "FLOAT";
    GlueRecordType["INT"] = "INT";
    GlueRecordType["LONG"] = "LONG";
    GlueRecordType["SHORT"] = "SHORT";
    GlueRecordType["STRING"] = "STRING";
    GlueRecordType["TIMESTAMP"] = "TIMESTAMP";
})(GlueRecordType || (GlueRecordType = {}));
export var JoinType;
(function (JoinType) {
    JoinType["EQUIJOIN"] = "equijoin";
    JoinType["LEFT"] = "left";
    JoinType["LEFT_ANTI"] = "leftanti";
    JoinType["LEFT_SEMI"] = "leftsemi";
    JoinType["OUTER"] = "outer";
    JoinType["RIGHT"] = "right";
})(JoinType || (JoinType = {}));
export var PiiType;
(function (PiiType) {
    PiiType["ColumnAudit"] = "ColumnAudit";
    PiiType["ColumnMasking"] = "ColumnMasking";
    PiiType["RowAudit"] = "RowAudit";
    PiiType["RowMasking"] = "RowMasking";
})(PiiType || (PiiType = {}));
export var CompressionType;
(function (CompressionType) {
    CompressionType["BZIP2"] = "bzip2";
    CompressionType["GZIP"] = "gzip";
})(CompressionType || (CompressionType = {}));
export var QuoteChar;
(function (QuoteChar) {
    QuoteChar["DISABLED"] = "disabled";
    QuoteChar["QUILLEMET"] = "quillemet";
    QuoteChar["QUOTE"] = "quote";
    QuoteChar["SINGLE_QUOTE"] = "single_quote";
})(QuoteChar || (QuoteChar = {}));
export var Separator;
(function (Separator) {
    Separator["COMMA"] = "comma";
    Separator["CTRLA"] = "ctrla";
    Separator["PIPE"] = "pipe";
    Separator["SEMICOLON"] = "semicolon";
    Separator["TAB"] = "tab";
})(Separator || (Separator = {}));
export var TargetFormat;
(function (TargetFormat) {
    TargetFormat["AVRO"] = "avro";
    TargetFormat["CSV"] = "csv";
    TargetFormat["JSON"] = "json";
    TargetFormat["ORC"] = "orc";
    TargetFormat["PARQUET"] = "parquet";
})(TargetFormat || (TargetFormat = {}));
export var ParquetCompressionType;
(function (ParquetCompressionType) {
    ParquetCompressionType["GZIP"] = "gzip";
    ParquetCompressionType["LZO"] = "lzo";
    ParquetCompressionType["NONE"] = "none";
    ParquetCompressionType["SNAPPY"] = "snappy";
    ParquetCompressionType["UNCOMPRESSED"] = "uncompressed";
})(ParquetCompressionType || (ParquetCompressionType = {}));
export var UnionType;
(function (UnionType) {
    UnionType["ALL"] = "ALL";
    UnionType["DISTINCT"] = "DISTINCT";
})(UnionType || (UnionType = {}));
export var ExecutionClass;
(function (ExecutionClass) {
    ExecutionClass["FLEX"] = "FLEX";
    ExecutionClass["STANDARD"] = "STANDARD";
})(ExecutionClass || (ExecutionClass = {}));
var InvalidStateException = (function (_super) {
    __extends(InvalidStateException, _super);
    function InvalidStateException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidStateException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidStateException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidStateException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return InvalidStateException;
}(__BaseException));
export { InvalidStateException };
export var CrawlState;
(function (CrawlState) {
    CrawlState["CANCELLED"] = "CANCELLED";
    CrawlState["CANCELLING"] = "CANCELLING";
    CrawlState["ERROR"] = "ERROR";
    CrawlState["FAILED"] = "FAILED";
    CrawlState["RUNNING"] = "RUNNING";
    CrawlState["SUCCEEDED"] = "SUCCEEDED";
})(CrawlState || (CrawlState = {}));
export var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["EQUALS"] = "EQUALS";
})(LogicalOperator || (LogicalOperator = {}));
export var JobRunState;
(function (JobRunState) {
    JobRunState["ERROR"] = "ERROR";
    JobRunState["FAILED"] = "FAILED";
    JobRunState["RUNNING"] = "RUNNING";
    JobRunState["STARTING"] = "STARTING";
    JobRunState["STOPPED"] = "STOPPED";
    JobRunState["STOPPING"] = "STOPPING";
    JobRunState["SUCCEEDED"] = "SUCCEEDED";
    JobRunState["TIMEOUT"] = "TIMEOUT";
    JobRunState["WAITING"] = "WAITING";
})(JobRunState || (JobRunState = {}));
export var Logical;
(function (Logical) {
    Logical["AND"] = "AND";
    Logical["ANY"] = "ANY";
})(Logical || (Logical = {}));
export var TriggerState;
(function (TriggerState) {
    TriggerState["ACTIVATED"] = "ACTIVATED";
    TriggerState["ACTIVATING"] = "ACTIVATING";
    TriggerState["CREATED"] = "CREATED";
    TriggerState["CREATING"] = "CREATING";
    TriggerState["DEACTIVATED"] = "DEACTIVATED";
    TriggerState["DEACTIVATING"] = "DEACTIVATING";
    TriggerState["DELETING"] = "DELETING";
    TriggerState["UPDATING"] = "UPDATING";
})(TriggerState || (TriggerState = {}));
export var TriggerType;
(function (TriggerType) {
    TriggerType["CONDITIONAL"] = "CONDITIONAL";
    TriggerType["EVENT"] = "EVENT";
    TriggerType["ON_DEMAND"] = "ON_DEMAND";
    TriggerType["SCHEDULED"] = "SCHEDULED";
})(TriggerType || (TriggerType = {}));
export var NodeType;
(function (NodeType) {
    NodeType["CRAWLER"] = "CRAWLER";
    NodeType["JOB"] = "JOB";
    NodeType["TRIGGER"] = "TRIGGER";
})(NodeType || (NodeType = {}));
export var WorkflowRunStatus;
(function (WorkflowRunStatus) {
    WorkflowRunStatus["COMPLETED"] = "COMPLETED";
    WorkflowRunStatus["ERROR"] = "ERROR";
    WorkflowRunStatus["RUNNING"] = "RUNNING";
    WorkflowRunStatus["STOPPED"] = "STOPPED";
    WorkflowRunStatus["STOPPING"] = "STOPPING";
})(WorkflowRunStatus || (WorkflowRunStatus = {}));
export var TaskStatusType;
(function (TaskStatusType) {
    TaskStatusType["FAILED"] = "FAILED";
    TaskStatusType["RUNNING"] = "RUNNING";
    TaskStatusType["STARTING"] = "STARTING";
    TaskStatusType["STOPPED"] = "STOPPED";
    TaskStatusType["STOPPING"] = "STOPPING";
    TaskStatusType["SUCCEEDED"] = "SUCCEEDED";
    TaskStatusType["TIMEOUT"] = "TIMEOUT";
})(TaskStatusType || (TaskStatusType = {}));
var IllegalSessionStateException = (function (_super) {
    __extends(IllegalSessionStateException, _super);
    function IllegalSessionStateException(opts) {
        var _this = _super.call(this, __assign({ name: "IllegalSessionStateException", $fault: "client" }, opts)) || this;
        _this.name = "IllegalSessionStateException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, IllegalSessionStateException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return IllegalSessionStateException;
}(__BaseException));
export { IllegalSessionStateException };
export var DataFormat;
(function (DataFormat) {
    DataFormat["AVRO"] = "AVRO";
    DataFormat["JSON"] = "JSON";
    DataFormat["PROTOBUF"] = "PROTOBUF";
})(DataFormat || (DataFormat = {}));
export var CsvHeaderOption;
(function (CsvHeaderOption) {
    CsvHeaderOption["ABSENT"] = "ABSENT";
    CsvHeaderOption["PRESENT"] = "PRESENT";
    CsvHeaderOption["UNKNOWN"] = "UNKNOWN";
})(CsvHeaderOption || (CsvHeaderOption = {}));
export var ConnectionPropertyKey;
(function (ConnectionPropertyKey) {
    ConnectionPropertyKey["CONFIG_FILES"] = "CONFIG_FILES";
    ConnectionPropertyKey["CONNECTION_URL"] = "CONNECTION_URL";
    ConnectionPropertyKey["CONNECTOR_CLASS_NAME"] = "CONNECTOR_CLASS_NAME";
    ConnectionPropertyKey["CONNECTOR_TYPE"] = "CONNECTOR_TYPE";
    ConnectionPropertyKey["CONNECTOR_URL"] = "CONNECTOR_URL";
    ConnectionPropertyKey["CUSTOM_JDBC_CERT"] = "CUSTOM_JDBC_CERT";
    ConnectionPropertyKey["CUSTOM_JDBC_CERT_STRING"] = "CUSTOM_JDBC_CERT_STRING";
    ConnectionPropertyKey["ENCRYPTED_KAFKA_CLIENT_KEYSTORE_PASSWORD"] = "ENCRYPTED_KAFKA_CLIENT_KEYSTORE_PASSWORD";
    ConnectionPropertyKey["ENCRYPTED_KAFKA_CLIENT_KEY_PASSWORD"] = "ENCRYPTED_KAFKA_CLIENT_KEY_PASSWORD";
    ConnectionPropertyKey["ENCRYPTED_PASSWORD"] = "ENCRYPTED_PASSWORD";
    ConnectionPropertyKey["HOST"] = "HOST";
    ConnectionPropertyKey["INSTANCE_ID"] = "INSTANCE_ID";
    ConnectionPropertyKey["JDBC_CONNECTION_URL"] = "JDBC_CONNECTION_URL";
    ConnectionPropertyKey["JDBC_DRIVER_CLASS_NAME"] = "JDBC_DRIVER_CLASS_NAME";
    ConnectionPropertyKey["JDBC_DRIVER_JAR_URI"] = "JDBC_DRIVER_JAR_URI";
    ConnectionPropertyKey["JDBC_ENFORCE_SSL"] = "JDBC_ENFORCE_SSL";
    ConnectionPropertyKey["JDBC_ENGINE"] = "JDBC_ENGINE";
    ConnectionPropertyKey["JDBC_ENGINE_VERSION"] = "JDBC_ENGINE_VERSION";
    ConnectionPropertyKey["KAFKA_BOOTSTRAP_SERVERS"] = "KAFKA_BOOTSTRAP_SERVERS";
    ConnectionPropertyKey["KAFKA_CLIENT_KEYSTORE"] = "KAFKA_CLIENT_KEYSTORE";
    ConnectionPropertyKey["KAFKA_CLIENT_KEYSTORE_PASSWORD"] = "KAFKA_CLIENT_KEYSTORE_PASSWORD";
    ConnectionPropertyKey["KAFKA_CLIENT_KEY_PASSWORD"] = "KAFKA_CLIENT_KEY_PASSWORD";
    ConnectionPropertyKey["KAFKA_CUSTOM_CERT"] = "KAFKA_CUSTOM_CERT";
    ConnectionPropertyKey["KAFKA_SKIP_CUSTOM_CERT_VALIDATION"] = "KAFKA_SKIP_CUSTOM_CERT_VALIDATION";
    ConnectionPropertyKey["KAFKA_SSL_ENABLED"] = "KAFKA_SSL_ENABLED";
    ConnectionPropertyKey["PASSWORD"] = "PASSWORD";
    ConnectionPropertyKey["PORT"] = "PORT";
    ConnectionPropertyKey["SECRET_ID"] = "SECRET_ID";
    ConnectionPropertyKey["SKIP_CUSTOM_JDBC_CERT_VALIDATION"] = "SKIP_CUSTOM_JDBC_CERT_VALIDATION";
    ConnectionPropertyKey["USER_NAME"] = "USERNAME";
})(ConnectionPropertyKey || (ConnectionPropertyKey = {}));
export var ConnectionType;
(function (ConnectionType) {
    ConnectionType["CUSTOM"] = "CUSTOM";
    ConnectionType["JDBC"] = "JDBC";
    ConnectionType["KAFKA"] = "KAFKA";
    ConnectionType["MARKETPLACE"] = "MARKETPLACE";
    ConnectionType["MONGODB"] = "MONGODB";
    ConnectionType["NETWORK"] = "NETWORK";
    ConnectionType["SFTP"] = "SFTP";
})(ConnectionType || (ConnectionType = {}));
var IdempotentParameterMismatchException = (function (_super) {
    __extends(IdempotentParameterMismatchException, _super);
    function IdempotentParameterMismatchException(opts) {
        var _this = _super.call(this, __assign({ name: "IdempotentParameterMismatchException", $fault: "client" }, opts)) || this;
        _this.name = "IdempotentParameterMismatchException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, IdempotentParameterMismatchException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return IdempotentParameterMismatchException;
}(__BaseException));
export { IdempotentParameterMismatchException };
var ConcurrentModificationException = (function (_super) {
    __extends(ConcurrentModificationException, _super);
    function ConcurrentModificationException(opts) {
        var _this = _super.call(this, __assign({ name: "ConcurrentModificationException", $fault: "client" }, opts)) || this;
        _this.name = "ConcurrentModificationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConcurrentModificationException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ConcurrentModificationException;
}(__BaseException));
export { ConcurrentModificationException };
export var Permission;
(function (Permission) {
    Permission["ALL"] = "ALL";
    Permission["ALTER"] = "ALTER";
    Permission["CREATE_DATABASE"] = "CREATE_DATABASE";
    Permission["CREATE_TABLE"] = "CREATE_TABLE";
    Permission["DATA_LOCATION_ACCESS"] = "DATA_LOCATION_ACCESS";
    Permission["DELETE"] = "DELETE";
    Permission["DROP"] = "DROP";
    Permission["INSERT"] = "INSERT";
    Permission["SELECT"] = "SELECT";
})(Permission || (Permission = {}));
var ValidationException = (function (_super) {
    __extends(ValidationException, _super);
    function ValidationException(opts) {
        var _this = _super.call(this, __assign({ name: "ValidationException", $fault: "client" }, opts)) || this;
        _this.name = "ValidationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ValidationException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ValidationException;
}(__BaseException));
export { ValidationException };
export var TransformType;
(function (TransformType) {
    TransformType["FIND_MATCHES"] = "FIND_MATCHES";
})(TransformType || (TransformType = {}));
export var MLUserDataEncryptionModeString;
(function (MLUserDataEncryptionModeString) {
    MLUserDataEncryptionModeString["DISABLED"] = "DISABLED";
    MLUserDataEncryptionModeString["SSEKMS"] = "SSE-KMS";
})(MLUserDataEncryptionModeString || (MLUserDataEncryptionModeString = {}));
export var Compatibility;
(function (Compatibility) {
    Compatibility["BACKWARD"] = "BACKWARD";
    Compatibility["BACKWARD_ALL"] = "BACKWARD_ALL";
    Compatibility["DISABLED"] = "DISABLED";
    Compatibility["FORWARD"] = "FORWARD";
    Compatibility["FORWARD_ALL"] = "FORWARD_ALL";
    Compatibility["FULL"] = "FULL";
    Compatibility["FULL_ALL"] = "FULL_ALL";
    Compatibility["NONE"] = "NONE";
})(Compatibility || (Compatibility = {}));
export var SchemaStatus;
(function (SchemaStatus) {
    SchemaStatus["AVAILABLE"] = "AVAILABLE";
    SchemaStatus["DELETING"] = "DELETING";
    SchemaStatus["PENDING"] = "PENDING";
})(SchemaStatus || (SchemaStatus = {}));
export var SchemaVersionStatus;
(function (SchemaVersionStatus) {
    SchemaVersionStatus["AVAILABLE"] = "AVAILABLE";
    SchemaVersionStatus["DELETING"] = "DELETING";
    SchemaVersionStatus["FAILURE"] = "FAILURE";
    SchemaVersionStatus["PENDING"] = "PENDING";
})(SchemaVersionStatus || (SchemaVersionStatus = {}));
export var Language;
(function (Language) {
    Language["PYTHON"] = "PYTHON";
    Language["SCALA"] = "SCALA";
})(Language || (Language = {}));
export var CloudWatchEncryptionMode;
(function (CloudWatchEncryptionMode) {
    CloudWatchEncryptionMode["DISABLED"] = "DISABLED";
    CloudWatchEncryptionMode["SSEKMS"] = "SSE-KMS";
})(CloudWatchEncryptionMode || (CloudWatchEncryptionMode = {}));
export var JobBookmarksEncryptionMode;
(function (JobBookmarksEncryptionMode) {
    JobBookmarksEncryptionMode["CSEKMS"] = "CSE-KMS";
    JobBookmarksEncryptionMode["DISABLED"] = "DISABLED";
})(JobBookmarksEncryptionMode || (JobBookmarksEncryptionMode = {}));
export var S3EncryptionMode;
(function (S3EncryptionMode) {
    S3EncryptionMode["DISABLED"] = "DISABLED";
    S3EncryptionMode["SSEKMS"] = "SSE-KMS";
    S3EncryptionMode["SSES3"] = "SSE-S3";
})(S3EncryptionMode || (S3EncryptionMode = {}));
export var SessionStatus;
(function (SessionStatus) {
    SessionStatus["FAILED"] = "FAILED";
    SessionStatus["PROVISIONING"] = "PROVISIONING";
    SessionStatus["READY"] = "READY";
    SessionStatus["STOPPED"] = "STOPPED";
    SessionStatus["STOPPING"] = "STOPPING";
    SessionStatus["TIMEOUT"] = "TIMEOUT";
})(SessionStatus || (SessionStatus = {}));
export var PrincipalType;
(function (PrincipalType) {
    PrincipalType["GROUP"] = "GROUP";
    PrincipalType["ROLE"] = "ROLE";
    PrincipalType["USER"] = "USER";
})(PrincipalType || (PrincipalType = {}));
export var ResourceType;
(function (ResourceType) {
    ResourceType["ARCHIVE"] = "ARCHIVE";
    ResourceType["FILE"] = "FILE";
    ResourceType["JAR"] = "JAR";
})(ResourceType || (ResourceType = {}));
export var NotificationPropertyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ActionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AggregateOperationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AggregateFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GlueStudioSchemaColumnFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GlueSchemaFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AthenaConnectorSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AuditContextFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ColumnFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SchemaIdFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SchemaReferenceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SerDeInfoFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SkewedInfoFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var OrderFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StorageDescriptorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PartitionInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchCreatePartitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ErrorDetailFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PartitionErrorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchCreatePartitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeleteConnectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeleteConnectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PartitionValueListFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeletePartitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeletePartitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeleteTableRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TableErrorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeleteTableResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeleteTableVersionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TableVersionErrorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeleteTableVersionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetBlueprintsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LastActiveDefinitionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BlueprintFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetBlueprintsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetCrawlersRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LakeFormationConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LastCrawlInfoFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LineageConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RecrawlPolicyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ScheduleFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SchemaChangePolicyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CatalogTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeltaTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DynamoDBTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var JdbcTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MongoDBTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3TargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CrawlerTargetsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CrawlerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetCrawlersResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetCustomEntityTypesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CustomEntityTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetCustomEntityTypesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetDevEndpointsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DevEndpointFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetDevEndpointsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetJobsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamingDataPreviewOptionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var KafkaStreamingSourceOptionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CatalogKafkaSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var KinesisStreamingSourceOptionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CatalogKinesisSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CatalogSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BasicCatalogTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CustomCodeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DirectKafkaSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DirectKinesisSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DropDuplicatesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DropFieldsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var NullCheckBoxListFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DatatypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var NullValueFieldFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DropNullFieldsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DynamoDBCatalogSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FillMissingValuesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FilterValueFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FilterExpressionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3SourceAdditionalOptionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GovernedCatalogSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CatalogSchemaChangePolicyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GovernedCatalogTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var JDBCConnectorOptionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var JDBCConnectorSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var JDBCConnectorTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var JoinColumnFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var JoinFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MergeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MicrosoftSQLServerCatalogSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MicrosoftSQLServerCatalogTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MySQLCatalogSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MySQLCatalogTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var OracleSQLCatalogSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var OracleSQLCatalogTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PIIDetectionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PostgreSQLCatalogSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PostgreSQLCatalogTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RedshiftSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpsertRedshiftTargetOptionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RedshiftTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RelationalCatalogSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RenameFieldFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3CatalogSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3CatalogTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3DirectSourceAdditionalOptionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3CsvSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DirectSchemaChangePolicyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3DirectTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3GlueParquetTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3JsonSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3ParquetSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SelectFieldsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SelectFromCollectionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SparkConnectorSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SparkConnectorTargetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SqlAliasFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SparkSQLFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SpigotFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SplitFieldsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UnionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var JobCommandFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConnectionsListFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ExecutionPropertyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetPartitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PartitionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetPartitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetTriggersRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EventBatchingConditionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConditionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PredicateFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TriggerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetTriggersResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetWorkflowsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BlueprintDetailsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EdgeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CrawlFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CrawlerNodeDetailsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PredecessorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var JobRunFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var JobNodeDetailsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TriggerNodeDetailsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var NodeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var WorkflowGraphFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartingEventBatchConditionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var WorkflowRunStatisticsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var WorkflowRunFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var WorkflowFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetWorkflowsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchStopJobRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchStopJobRunErrorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchStopJobRunSuccessfulSubmissionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchStopJobRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchUpdatePartitionRequestEntryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchUpdatePartitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchUpdatePartitionFailureEntryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchUpdatePartitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CancelMLTaskRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CancelMLTaskRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CancelStatementRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CancelStatementResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CheckSchemaVersionValidityInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CheckSchemaVersionValidityResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateBlueprintRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateBlueprintResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateCsvClassifierRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateGrokClassifierRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateJsonClassifierRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateXMLClassifierRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateClassifierRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateClassifierResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PhysicalConnectionRequirementsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConnectionInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateConnectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateConnectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateCrawlerRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateCrawlerResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateCustomEntityTypeRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateCustomEntityTypeResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DataLakePrincipalFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PrincipalPermissionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DatabaseIdentifierFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DatabaseInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateDatabaseRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateDatabaseResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateDevEndpointRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateDevEndpointResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateJobResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GlueTableFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FindMatchesParametersFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TransformParametersFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MLUserDataEncryptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TransformEncryptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateMLTransformRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateMLTransformResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreatePartitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreatePartitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PartitionIndexFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreatePartitionIndexRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreatePartitionIndexResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateRegistryInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateRegistryResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RegistryIdFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateSchemaInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateSchemaResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CodeGenEdgeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CodeGenNodeArgFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CodeGenNodeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateScriptRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateScriptResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CloudWatchEncryptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var JobBookmarksEncryptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3EncryptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EncryptionConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateSecurityConfigurationRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateSecurityConfigurationResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SessionCommandFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateSessionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SessionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateSessionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TableIdentifierFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TableInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateTableRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateTableResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateTriggerRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateTriggerResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ResourceUriFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UserDefinedFunctionInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateUserDefinedFunctionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateUserDefinedFunctionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateWorkflowRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateWorkflowResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteBlueprintRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteBlueprintResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
